import "./axios/axiosConfig";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { ContextProvider } from "./context/providerComposer";
import { QueryClient, QueryClientProvider } from "react-query";

// STYLES
import "./styles/reset.css";
import "./styles/globalStyles.css";
import {MsalProvider} from "@azure/msal-react";
import { bootstrapMsal } from "./auth/bootstrapMsal";
import { msalInstance } from "./auth/msalClient";

const queryClient = new QueryClient();

const renderApp = () => {
  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <Router>
            <ContextProvider>
              <App />
            </ContextProvider>
          </Router>
        </MsalProvider>
    </QueryClientProvider>,
    document.getElementById("root"),
  );
};

bootstrapMsal()
  .catch((error) => {
    // Avoid blocking startup if MSAL initialization fails.
    console.error("MSAL bootstrap failed", error);
  })
  .finally(() => {
    renderApp();
  });
